import clsx from "clsx";
import FsLightbox from "fslightbox-react";
import * as _ from "lodash";
import React, { useState } from "react";
import { Tabs } from "../../common/components/tabs/Tabs";
import { ProductItem } from "./ProductItem";
import { productPageItemType } from "../../common/types/product";

interface ProductTabsProps {
	description?: string;
	inverted?: boolean;
	subtitle?: string;
	tabs: productPageItemType[];
	title: string;
}

export function ProductTabs({
	title,
	subtitle = "What's included",
	description,
	tabs,
	inverted = false,
}: ProductTabsProps) {
	const [toggler, setToggler] = useState(false);
	const [zoomSlideImage, setZoomSlideImage] = useState(tabs[0].visual.url);

	const handleZoomButtonClick = (image) => {
		setToggler(!toggler);
		setZoomSlideImage(image);
	};

	let tabsContent;

	if (tabs.length === 1) {
		const { title, description, descriptionBottom, list, visual } = tabs[0];
		tabsContent = (
			<ProductItem
				title={title}
				description={description}
				descriptionBottom={descriptionBottom}
				list={list}
				visual={visual}
				onZoomButtonClick={handleZoomButtonClick}
			/>
		);
	} else {
		const tabsDefinition = tabs.map((item) => {
			const { title, description, descriptionBottom, list, visual } =
				item;

			return {
				title,
				id: _.camelCase(title),
				content: (
					<ProductItem
						title={title}
						description={description}
						descriptionBottom={descriptionBottom}
						list={list}
						visual={visual}
						onZoomButtonClick={handleZoomButtonClick}
					/>
				),
			};
		});

		tabsContent = <Tabs definition={tabsDefinition} />;
	}

	return (
		<section
			className={clsx("section--product-tabs", {
				"section--product-tabs__inverted": inverted,
			})}
		>
			<div className="container">
				{subtitle && <p className="subtitle">{subtitle}</p>}

				<h2 className="section-title">{title}</h2>

				{description && (
					<p className="section-description">{description}</p>
				)}

				{tabsContent}

				<FsLightbox toggler={toggler} sources={[zoomSlideImage]} />
			</div>
		</section>
	);
}
